<template>
    <div class="lawsuit_3" v-loading="loading">
         <div class="form_box">
            <div class="form_flex">
                <div class="form_titles">
                    <span>*</span>
                    案情描述
                </div>
                <div class="inputs">
                    <el-input type="textarea" v-model="form.mater_file" placeholder="请填写"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_titles">
                    <span>*</span>
                    咨询内容
                </div>
                <div class="inputs">
                    <el-input type="textarea" v-model="form.content" placeholder="请填写"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_titles">
                    证据材料
                </div>
                <div class="inputs2">
                    您上传的材料需满足如下要求：内容清晰完整；图片无黑边；图片正向拍摄
                </div>
            </div>
            <div class="form_flex">
                <div class="form_titles">
                </div>
                <div class="inputs3">
                    <div class="img_flex">
                        <div class="img_item" v-for="(item,index) in prove_imgs" :key="index">
                            <img :src="item.path" alt="" class="imgs">
                            <img src="@/assets/img/index/comments_case/clear.png" class="img_clear" @click="handle_img_claer(index,'prove_imgs')" alt="">
                        </div>
                        <div class="img_add" @click="handle_img_add('prove_imgs')">
                            <img src="@/assets/img/index/legal/img_up.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_titles">
                    其他材料
                </div>
                <div class="inputs2">
                    可上传原告、被告、第三人的身份证明等其他材料；您上传的材料需满足如下要求：内容清晰完整；图片无黑边；图片正向拍摄
                </div>
            </div>
            <div class="form_flex">
                <div class="form_titles">
                </div>
                <div class="inputs3">
                    <div class="img_flex">
                        <div class="img_item" v-for="(item,index) in other_imgs" :key="index">
                            <img :src="item.path" alt="" class="imgs">
                            <img src="@/assets/img/index/comments_case/clear.png" class="img_clear" @click="handle_img_claer(index,'other_imgs')" alt="">
                        </div>
                        <div class="img_add" @click="handle_img_add('other_imgs')">
                            <img src="@/assets/img/index/legal/img_up.png" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="form_flex">
                <div class="form_titles">
                    其他补充
                </div>
                <div class="inputs">
                    <el-input type="textarea" v-model="form.o_content" placeholder="补充当事人所在地区或案件发生所在地区等其他信息"></el-input>
                </div>
            </div>
         </div>
         <div class="chekcs">
            <el-checkbox v-model="checked"></el-checkbox>
            我已阅读并同意 
            <span @click="handle_new(115)">《网上送达诉讼文书确认书》</span>
            <span @click="handle_new(116)">《诚信诉讼及信用风险提示》</span>
            <span @click="handle_new(117)">《诉讼风险提示》</span>
            <span @click="handle_new(118)">《电子送达告知书》</span>
         </div>

         <div class="btns_flex">
            <div class="btns1" @click="handle_end">提交</div>
            <div class="btns2" @click="handle_qx">取消</div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>



    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 
import upload from '@/components/upload/upload.vue'
 


export default {
    components: {
        upload,
        
    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png','pdf','docx']),
            loading:false,
            checked:false,
            form:{
                mater_file:'',//案件描述 （简）
                content:'',//咨询内容
                prove_imgs:'',//证明材料（多图）
                other_imgs:'',//其他材料（多img）
                o_content:'',//其他补充
            },
            prove_imgs:[],
            other_imgs:[],
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {

    },
    methods: {
        handle_new(id){
            window.open('/agreement?id='+id)
        },
        //删除
        handle_img_claer(index,form_text){
            this[form_text].splice(index,1)
        },
         //触发上传
        handle_img_add(text){
            let datas={
                form_text:text
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this[datas.form_text].push(res_data)
        },
        //删除图片
        handle_clear(index,text){
            this.file_list.splice(index,1)
        },
        handle_end(){
            if(!this.checked){
                alertErr('请阅读协议')
                return
            }
            if(!this.form.mater_file){
                alertErr('请输入案情描述')
                return
            }
            if(!this.form.content){
                alertErr('请输入咨询内容')
                return
            }
            this.form.prove_imgs=JSON.stringify(this.prove_imgs)
            this.form.other_imgs=JSON.stringify(this.other_imgs)
            this.loading=true
            this.$api("appointStep3", {
                order_id:this.$route.query.order_id,
                ...this.form,
			}, "post").then((res) => {
                this.loading = false
                console.log('第三步提交',res)
                if (res.code == 1) {
                    console.log('提交',this.form)
                    this.$router.push({
                        path:'/Legal_pay',
                        query:{
                            order_id:this.$route.query.order_id,
                            pro_id:this.$route.query.pro_id,
                        }
                    })
                } else {
                    alertErr(res.msg)
                }
            });


         
        },
        handle_qx(){
            this.$router.back()

        }



    },

}
</script>
<style scoped lang="less">
.lawsuit_3{
    padding:64px 22px 0px 160px  ;
    .form_box{
        padding-bottom: 20px;
        border-bottom: 2px dashed  #B9B9B9;

        .form_flex{
            display: flex;
            // align-items: center;
            margin-bottom: 24px;
            .form_titles{
                width: 100px;
                text-align: right;
                display: flex;
                align-items: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                height: 40px;
                padding-right: 24px;
                flex-shrink: 0;
                span{
                    color: #FD4C5C;  
                }

            }
            .inputs{
                width: 740px;
            }
            .inputs2{
                width: 740px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                height: 40px;
                line-height: 40px;
            }
            .inputs3{
                width: 740px;
                // display: flex;
                .img_flex{
                    display: flex;
                    flex-wrap: wrap;
                    .img_item{
                        width: 80px;
                        height: 80px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        position: relative;
                        .img_clear{
                            position: absolute;
                            right: 0;
                            top: 0;
                            width: 15px;
                            height: 15px;
                            cursor: pointer;
                        }
                        .imgs{
                            width: 80px;
                            height: 80px;
                        }
                    }
                    .img_add{
                        width: 80px;
                        height: 80px;
                        cursor: pointer;
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                }
            }
        }
    }
    .chekcs{
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        padding-top: 18px;
        span{
            color: #377CFD;
            cursor: pointer;
        }
    }
    .btns_flex{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 46px;
        .btns1{
            width: 134px;
            height: 40px;
            background: #377CFD;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            text-align: center;
            line-height: 40px;
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;

        }
        .btns2{
            width: 134px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #377CFD;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin-left: 16px;
        }
    }
  
}

</style>